<template>
        <v-container fluid justify-center>
        <v-layout
          justify-center
          align-center column
        >    

 <h1 class="white--text mb-6 mt-4 display-2 text-xs-center font-weight-bold" >Your guide to a true zero emission marine project</h1>
      <v-col md="8">
  
 <v-row no-gutters style="margin-top:40px">
  <v-col md="6" xs="12">
        <v-btn v-if="!user" class="black--text text--lighten-3"
    
    
    color="secondary"
  large
  elevation="2"
    to="/login"
>Logga in</v-btn>

  
    </v-col>
    
      <v-col md="6" xs="12">
           <v-btn v-if="!user" class="black--text text--lighten-3"
    
 large
    color="secondary"
    to="register"
  
  elevation="2"
>Registrera</v-btn>
    </v-col>
   
 </v-row>
 
    </v-col>
    <v-img

style="margin-top:50px"
  max-width="400"
  src="../assets/powercell_logo_white.png"
></v-img>
    
       
      

        </v-layout>
      </v-container>
</template>

<script>
// @ is an alias to /src

import {mapState} from 'vuex'
export default {
  name: 'Home',
  components: {
  },
   computed: {
    ...mapState(['user']),
    displayName () {
      return !this.user ? this.user.email : '';
    }
    
  },
   watch: {
    user (auth) {
      if(auth){
        this.$router.replace("menu")
      }
    }},
}
</script>
